const TOKEN_KEY = 'token'
const USER_KEY = 'loginToken'

// 解析用户信息
function parseUser (value) {
    if (!value) {
        return null
    }

    try {
        return JSON.parse(value)
    } catch (error) {
        localStorage.removeItem(USER_KEY)
        return null
    }
}

//获取本地存储token
export function getToken () {
    return localStorage.getItem(TOKEN_KEY) || ''
}

//获取本地存储用户信息
export function getUser () {
    return parseUser(localStorage.getItem(USER_KEY))
}

//判断是否登录
export function isLoggedIn () {
    return Boolean(getToken())
}

//保存token和用户信息到本地存储
export function saveAuth (token, user) {
    if (token) {
        localStorage.setItem(TOKEN_KEY, token)
    }

    if (user) {
        localStorage.setItem(USER_KEY, JSON.stringify(user))
    }
}

//保存用户信息到本地存储
export function saveUser (user) {
    if (!user) {
        localStorage.removeItem(USER_KEY)
        return
    }

    localStorage.setItem(USER_KEY, JSON.stringify(user))
}

//清除本地存储的token和用户信息
export function clearAuth () {
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(USER_KEY)
}
